import {Injectable, signal} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomerModalStateService {
  public updateModal = signal<boolean>(false);
  public generalUpdateModal = signal<boolean>(false);
  public addressesUpdateModal = signal<boolean>(false);
  public contactPersonspdateModal = signal<boolean>(false);

  reset(): void {
    this.updateModal.set(false);
    this.generalUpdateModal.set(false);
    this.addressesUpdateModal.set(false);
    this.contactPersonspdateModal.set(false);
  }
}
